import { useState } from "react";
import {
  FirstTabContentWrapper,
  SecondTabContentWrapper,
  TabList,
  TabOneContent,
  TabOneDate,
  TabOneTitle,
  TabPanel,
  TabTwoContent,
  TabTwoDate,
  TabTwoTitle,
  TabsWrapper,
  ViewCaseStudyButton,
} from "./VerticalTabs.styled";

function VerticalTabs() {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <TabsWrapper className="tabs">
      <TabList className="tab-list">
        <button
          className={`tab ${activeTab === 0 ? "active" : ""}`}
          onClick={() => setActiveTab(0)}
        >
          Elixis Trade
        </button>
        <button
          className={`tab ${activeTab === 1 ? "active" : ""}`}
          onClick={() => setActiveTab(1)}
        >
          Kreativa
        </button>
        <button
          className={`tab ${activeTab === 2 ? "active" : ""}`}
          onClick={() => setActiveTab(2)}
        >
          STech Technology
        </button>
      </TabList>
      <div className="tab-content">
        <TabPanel className="tab-panel" hidden={activeTab !== 0}>
          <FirstTabContentWrapper className="FirstTabContent">
            <TabOneTitle>
              Case study on{" "}
              <span className="allow-select">
                <a href="https://elixistrade.com/">elixistrade.com</a>
              </span>
            </TabOneTitle>
            <TabOneDate>Oct 2022 - Feb 2023</TabOneDate>
            <TabOneContent className="TabOneContent">
              <p>
                &gt; Developed a new website from scratch using
                industry-standard tools like Figma and React, collaborating with
                clients to understand project goals and translate them into
                effective design solutions.
              </p>

              <p>
                &gt; Implemented responsive design principles to ensure optimal
                functionality across various devices and screen sizes,
                leveraging React, JavaScript, HTML, and CSS for seamless
                interactivity, navigation, and performance.
              </p>
              <p>
                &gt; Applied SEO best practices for improved visibility and
                ranking, successfully launching the website and providing
                ongoing support, including bug fixes, feature enhancements, and
                content updates as needed.
              </p>
            </TabOneContent>
          </FirstTabContentWrapper>
        </TabPanel>
        <TabPanel className="tab-panel" hidden={activeTab !== 1}>
          <FirstTabContentWrapper className="FirstTabContent">
            <TabOneTitle>
              Case study on{" "}
              <span className="allow-select">
                <a href="https://kreativa.com.mk/">kreativa.com.mk</a>
              </span>
            </TabOneTitle>
            <TabOneDate>May 2022 - Oct 2022</TabOneDate>
            <TabOneContent className="TabOneContent">
              <p>
                &gt; Enhancing an Outdated Website to Improve User Experience
                and Revenue
              </p>
              <a href="#CaseStudy">
                <ViewCaseStudyButton>View Case Study</ViewCaseStudyButton>
              </a>
            </TabOneContent>
          </FirstTabContentWrapper>
        </TabPanel>
        <TabPanel className="tab-panel" hidden={activeTab !== 2}>
          <SecondTabContentWrapper className="SecondTabContent">
            <TabTwoTitle>
              Internship as a Junior FrontEnd Developer
              <span> @ StechTecnology</span>
            </TabTwoTitle>
            <TabTwoDate>Sep 2020 - Dec 2020</TabTwoDate>
            <TabTwoContent className="TabTwoContent">
              <p>
                &gt; During my internship at the firm, I had the opportunity to
                gain valuable knowledge and practical experience in front-end
                web development. I was tasked with creating custom components
                using React, a popular JavaScript library for building user
                interfaces.
              </p>
              <p>
                &gt; Through this project, I gained a deep understanding of
                React and its practical applications in web development. I
                learned how to create reusable components that can be easily
                integrated into larger web applications, and how to optimize
                these components for performance and scalability.
              </p>
              <p>
                &gt; Additionally, I was able to hone my skills in solving
                responsive web design problems, such as ensuring that the
                website looks and functions correctly on a variety of different
                screen sizes and devices. I developed a keen eye for detail and
                an understanding of the importance of user experience in web
                design.
              </p>
            </TabTwoContent>
          </SecondTabContentWrapper>
        </TabPanel>
      </div>
    </TabsWrapper>
  );
}

export default VerticalTabs;
